"use client";

/**
 * ReferralTracker
 *
 * Mounted in the root layout next to AttributionTracker. On first load,
 * checks `?ref=CODE` and writes the referral cookie if valid. First-touch
 * wins — won't overwrite an existing cookie unless the URL explicitly
 * passes a new code AND the existing one is different (current code:
 * first-touch only, matching attribution semantics).
 *
 * Renders nothing.
 */

import { useEffect } from "react";
import { detectReferralFromUrl, writeReferralCookie } from "@/lib/affiliate/referral-cookie";

export default function ReferralTracker() {
  useEffect(() => {
    const code = detectReferralFromUrl();
    if (code) {
      writeReferralCookie(code);
    }
  }, []);

  return null;
}
